var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const celloDesktopLauncherSelector = '.js-cello_referral_custom_launcher';
const logOutSelector = '.js-shutdown_cello';
window.cello = window.cello || { cmd: [] };
window.up.compiler(celloDesktopLauncherSelector, function (launcher) {
    const data = launcher.dataset.cello && JSON.parse(launcher.dataset.cello);
    const updateToken = () => __awaiter(this, void 0, void 0, function* () {
        const url = new URL(data.tokenRefreshUrl);
        url.searchParams.append('token', data.token);
        window.cello.cmd.push((cello) => __awaiter(this, void 0, void 0, function* () {
            try {
                const resp = yield fetch(url);
                const jsonResponse = yield resp.json();
                yield cello.updateToken(jsonResponse.data.token);
            }
            catch (error) {
                console.log('error updating cello token:', error); // eslint-disable-line no-console
            }
        }));
    });
    window.cello.cmd.push(function (cello) {
        cello.boot({
            productId: data.productId,
            token: data.token,
            hideDefaultLauncher: true,
            customLauncherSelector: celloDesktopLauncherSelector,
            productUserCountryCode: data.countryCode,
            language: data.locale,
            productUserDetails: {
                firstName: data.user.firstName,
                lastName: data.user.lastName,
                email: data.user.email
            },
            onTokenExpiring: updateToken,
            onTokenExpired: updateToken
        });
    });
});
window.up.compiler(logOutSelector, function (element) {
    window.up.on(element, 'click', undefined, () => {
        window.cello.cmd.push(function (cello) {
            cello.shutdown();
        });
    });
});
export const maybeAddCelloUccToForm = (form) => {
    var _a;
    const ucc = (_a = document.cookie
        .split('; ')
        .find(row => row.startsWith('cello-referral='))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    if (ucc) {
        const celloInput = document.createElement('input');
        celloInput.type = 'hidden';
        celloInput.name = 'publication[cello_universal_campaign_code]';
        celloInput.value = ucc;
        form.appendChild(celloInput);
    }
};
